import { message } from "antd";
import { CreateTfsSrpYearRate } from "../../api/CreateTfsSrpYearRate";
import { useAPIResponse } from "../global/useApiResponse";

export const useCreateTfsSrpYearRate = async (payload: any) => {
  await message.loading("Creating TFS SRP Year Rate..", 2);
  const response = await CreateTfsSrpYearRate(payload);

  return useAPIResponse(response);
};
